import { observer } from "mobx-react-lite"
import { useEffect } from "react"
import { Outlet } from "react-router-dom"
import customerStore from "features/organizations/customers/store/customer-store"
import LowSpinner from "components/common/low-spinner"
import usersStore from "features/users/store/users-store"
import { useIntl } from "@metsooutotec/modes-react-components"

const CustomersListLoader: React.FC = observer(() => {
    const { formatMessage } = useIntl()

    useEffect(() => {
        if (!customerStore.customers.length && !customerStore.customersLoading) {
            customerStore.loadAllCustomers()
        }

        if (!usersStore.users.length && !usersStore.usersLoading) {
            usersStore.loadAllUsersAsync()
        }
    }, [])

    const isUsersLoading = usersStore.usersLoading || !usersStore.users.length
    const isCustomersLoading = customerStore.customersLoading || !customerStore.customers.length

    if (isUsersLoading) {
        return <LowSpinner id={formatMessage("users.loading")} />
    }

    if (isCustomersLoading) {
        return <LowSpinner id={formatMessage("customer.loading")} />
    }

    return <Outlet />
})

export default CustomersListLoader
